export default {
    encounters: [],
    encountersCursor: null,
    hasMoreEncounters: true,
    loadingEncounters: false,
    selectedEncounter: null,
    anamnesis: null,
    physicalExam: null,
    diagnoses: [],
    vaccinations: [],
    vaccinationSchedule: [],
    loadingVaccinations: false,
    labExams: [],
    loadingLabExams: false,
    hospitalizations: [],
    loadingHospitalizations: false,
    prescriptions: [],
    loadingPrescriptions: false,
    pagination: {
        encounters: { cursor: null, hasMore: true, loading: false, error: null, generation: 0 },
        vaccinations: { cursor: null, hasMore: true, loading: false, error: null, generation: 0 },
        labExams: { cursor: null, hasMore: true, loading: false, error: null, generation: 0 },
        hospitalizations: { cursor: null, hasMore: true, loading: false, error: null, generation: 0 },
        prescriptions: { cursor: null, hasMore: true, loading: false, error: null, generation: 0 }
    },
    /**
     * O backend devolve no maximo PAGE_LIMIT itens por tipo (5 nas prescricoes).
     * Quando a lista volta exatamente no limite existem registros mais antigos
     * que a tela nao esta exibindo, e o usuario precisa saber disso.
     * As chaves ficam declaradas aqui para manter a reatividade no Vue 2.
     */
    truncated: {
        encounters: false,
        vaccinations: false,
        labExams: false,
        hospitalizations: false,
        prescriptions: false
    },
    timelineFilter: 'all',
    hideDrafts: false
}
